<template>
  <section>
    <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="[url]"  :zIndex="3000" />
    <div class="imglist">
      <template v-if="Model==1">
        <div
          class="img"
          :style="{backgroundImage:'url(' + BaseUrl + item.Path + ')'}"
          v-for="item in fileList"
          :key="item.Id"
        >
          <div class="expand" @click="onPreview( BaseUrl + item.Path)">
            <i class="el-icon-view"></i>
          </div>
          <div v-show="item.Path!=CurrentCover" class="delete" @click="deleteFile(item.Id)">
            <i class="el-icon-error"></i>
          </div>
          <div v-show="item.Path==CurrentCover" class="coverImg">
            <img src="/static/images/cover.png" />
          </div>
          <div
            v-if="IsCoverEdit"
            v-show="item.Path!=CurrentCover"
            class="recover"
            @click="recoverImg(item.Id,item.Path)"
          >
            <img src="/static/images/recover.png" />
          </div>
        </div>
      </template>
      <template v-if="Model==2">
        <div
          class="file"
          :style="{backgroundImage:'url(' + getFilePath(item.Path,item.Ext) + ')'}"
          v-for="item in fileList"
          :key="item.Id"
        >
          <div
            class="expand"
            v-if="!IsFile(item.Ext)"
            @click="onPreviewFile(IsFile(item.Ext), BaseUrl + item.Path)"
          >
            <i class="el-icon-view"></i>
          </div>
          <div class="delete" @click="deleteFile(item.Id)">
            <i class="el-icon-error"></i>
          </div>
          <el-link target="_blank" :href="BaseUrl + item.Path" :underline="false" class="download">
            <i class="fa fa-download"></i>
          </el-link>
          <div class="name" v-if="IsFile(item.Ext)">{{item.Name}}</div>
        </div>
      </template>
      <template v-if="Model==3">
        <div
          class="file"
          :style="{backgroundImage:'url(' + getFilePath(item.Path,item.Ext) + ')'}"
          v-for="item in fileList"
          :key="item.Id"
        >
          <div
            class="expand"
            v-if="!IsFile(item.Ext)"
            @click="onPreviewFile(IsFile(item.Ext), BaseUrl + item.Path)"
          >
            <i class="el-icon-view"></i>
          </div>
          <el-link target="_blank" :href="BaseUrl + item.Path" :underline="false" class="download">
            <i class="fa fa-download"></i>
          </el-link>
          <div class="name" v-if="IsFile(item.Ext)">{{item.Name}}</div>
        </div>
      </template>
    </div>
    <template v-if="Model<3">
      <el-upload
        ref="uploadFile"
        class="upload-img-list"
        :auto-upload="false"
        multiple
        action="xxx"
        :limit="10"
        :list-type="listType"
        :accept="accept"
      >
        <el-button size="small" type="primary">{{$t('uploadClick')}}</el-button>
        <div slot="tip" class="el-upload__tip">{{$t('uploadtipStart')+accept+$t('uploadtipEnd')}}</div>
      </el-upload>
    </template>
  </section>
</template>
<script>
// 导入组件
import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import { getShopFileList, deleteShopFile, replaceShopCover } from "@/api/api";
import util from "util/date";
export default {
  components: { ElImageViewer },
  name: "UploadShopFiles",
  data() {
    return {
      CurrentCover: this.Cover,
      fileList: [],
      showViewer: false,
      url: "",
    };
  },
  props: {
    Model: {
      type: Number,
      default: 1,
    },
    IsCoverEdit: {
      type: Boolean,
      default: true,
    },
    BaseUrl: String,
    Cover: String,
    accept: String,
    listType: String,
    value: Number,
    TableId: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    IsFile(ext) {
      switch (ext) {
        case ".png":
        case ".gif":
        case ".jpg":
        case ".jpeg":
        case ".webp":
          return false;
      }
      return true;
    },
    getFilePath(path, ext) {
      switch (ext) {
        case ".png":
        case ".gif":
        case ".jpg":
        case ".jpeg":
        case ".webp":
          return this.BaseUrl + path;
      }
      return "/static/images/" + ext + ".png";
    },
    FilesBase64() {
      var fileData = [];
      var _this = this;
      _this.$refs.uploadFile.uploadFiles.forEach(function (item, index, array) {
        _this.getBase64(item.raw).then((res) => {
          fileData.push(res);
        });
      });
      return fileData;
    },
    Files() {
      return this.$refs.uploadFile.uploadFiles;
    },
    clearFiles() {
      this.$emit("input", null);
      return this.$refs.uploadFile.clearFiles();
    },
    onPreview(url) {
      this.url = url;
      this.showViewer = true;
    },
    onPreviewFile(isFile, url) {
      if (!isFile) {
        this.url = url;
        this.showViewer = true;
      }
    },
    // 关闭查看器
    closeViewer() {
      this.showViewer = false;
    },
    deleteFile(id) {
      let _this = this;
      this.$confirm(this.$t("deleteImgPrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = { id: id };
          deleteShopFile(para).then((res) => {
            if (util.isEmt.format(res)) {
              return;
            }
            if (res.data.success) {
              this.fileList.forEach(function (item, index, array) {
                if (item.Id == id) {
                  _this.fileList.splice(index, 1);
                }
              });
              this.$message({
                message: this.$t("deleteSuccess"),
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    downloadFile(id) {
      getFileDownload(para).then((res) => {});
    },
    recoverImg(id, imgPath) {
      this.$confirm(this.$t("recoverImgPrompt"), this.$t("prompt"), {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          let para = {
            id: id,
            primaryId: this.value,
          };
          replaceShopCover(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            if (res.data.success) {
              this.$message({
                message: this.$t("success"),
                type: "success",
              });
              this.CurrentCover = imgPath;
              this.$emit("Cover", this.CurrentCover);
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },
    getFileList() {
      let para = { tableId: this.TableId, PrimaryId: this.value };
      getShopFileList(para).then((res) => {
        this.fileList = res.data.response;
      });
    },
  },
  watch: {
    value() {
      this.getFileList();
    },
    Cover() {
      this.CurrentCover = this.Cover;
    },
  },
  mounted() {
    this.getFileList();
  },
};
</script>
<style scoped>
.imglist {
  display: flex;
  flex-wrap: wrap;
}

.imglist .img {
  position: relative;
  width: 150px;
  height: 150px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border: 1px dashed #d9d9d9;
  margin: 3px;
}

.imglist .img .delete,
.imglist .file .delete {
  display: none;
  position: absolute;
  right: 5px;
  top: 0;
  font-size: 28px;
  cursor: pointer;
}

.imglist .img:hover .delete,
.imglist .file:hover .delete,
.imglist .file:hover .download,
.imglist .img:hover .recover,
.imglist .img:hover .expand,
.imglist .file:hover .expand {
  display: block;
}

.imglist .img .coverImg {
  position: absolute;
  left: 0;
  top: 0;
}

.imglist .img .recover {
  width: 32px;
  height: 32px;
  display: none;
  position: absolute;
  bottom: 5px;
  left: 50%;
  margin-left: -16px;
  cursor: pointer;
}
.imglist .file {
  position: relative;
  width: 150px;
  height: 150px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
  border: 1px dashed #d9d9d9;
  margin: 3px;
}
.imglist .file .download {
  display: none;
  position: absolute;
  left: 7px;
  top: 2px;
  font-size: 26px;
  cursor: pointer;
}
.imglist .file .name {
  position: absolute;
  width: calc(100% - 6px);
  left: 0;
  bottom: 0;
  font-size: 13px;
  line-height: 15px;
  padding: 3px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.5);
}
.imglist .expand {
  display: none;
  position: absolute;
  left: calc(50% - 15px);
  top: calc(50% - 15px);
  font-size: 30px;
  color: #d9d9d9;
  cursor: pointer;
}
</style>